var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 0.5,
    width: 10,
    height: 15,
    rx: 2,
    ry: 2,
    stroke: "#9FA2B4",
    strokeWidth: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 1.5,
    width: 4,
    height: 0.5,
    rx: 0.25,
    fill: "#9FA2B4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 13,
    r: 0.75,
    fill: "#9FA2B4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a4509f17363810bf6dcfaa11baeae0e6.svg";
export { ForwardRef as ReactComponent };